import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { v4 as SessionID } from 'uuid';
@Injectable({
  providedIn: 'root'
})
export class TradereferenceService {
  public _TradereferenceService = environment.TradereferenceService;
  public _httpOptions;
  public sessionId : string
  constructor(private http: HttpClient) { 
    this.sessionId = sessionStorage["SessionId"]
    this._httpOptions = {
      headers: new HttpHeaders({ 'SessionId':this.sessionId })
    };
  }
  GetPageInitializeDetails(): Observable < any > {
    var Query = this._TradereferenceService ;
    // console.log(Query);
    return this.http.get<{ data: any }>(Query,this._httpOptions);
  }
  GetById(customercode:string): Observable<any>{
    var Query = this._TradereferenceService + '/GetById' +'/'+ customercode ;
    // console.log(Query);
    return this.http.get<{ data: any }>(Query,this._httpOptions);
  }
  UpsertCustomerSiteTradeReference(customersite: object) {
    // console.log("Create");
    var Query = this._TradereferenceService  +'/UpsertCustomerSiteTradeReference';
    return this.http.post<{ data: any }>(Query, customersite,this._httpOptions);
  }
  SubmitPreQuote(customersite: object) {
    // console.log("Create");
    var Query = this._TradereferenceService  +'/SubmitPreQuote';
    return this.http.post<{ data: any }>(Query, customersite,this._httpOptions);
  }
}
